import axios from 'axios';

export let axiosFaceItInstance = null;

export const initFaceItAxios = (apiUrl, headers) => {
	axiosFaceItInstance = axios.create({
		baseURL: apiUrl,
		timeout: 60000,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${process.env.GATSBY_FACEIT_API_KEY}`,
		},
	});

	axiosFaceItInstance.interceptors.response.use(
		(response) => {
			if ('data' in response) {
				return response.data;
			}

			return response;
		},
		(error) => {
			console.error('Interceptor error', error, error.message);

			if (error.response.status === 401) {
				return Promise.reject();
			}

			return Promise.reject({
				code: error.response.status,
			});
		}
	);
};
